import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import routerSelectors from 'store/selectors/router'
import projectActions from 'store/modules/project'
import bookActions from 'store/modules/booking'

const BookingProjectWrapper = ({
  children,
}) => {
  const dispatch = useDispatch()
  const params = useSelector(routerSelectors.params)
  useEffect(() => {
    if(!params.project) return
    dispatch(projectActions.setCurrentProjectId(params.project))
    dispatch(bookActions.loadProject({
      id: params.project,
    }))
  }, [
    params.project,
  ])
  return children
}

export default BookingProjectWrapper